<script lang="ts">
    import type { OdEditModalManager } from "./OdEditModalManager";

    export let manager: OdEditModalManager;
    export let x: number;
    export let y: number;

    let value: number = manager.getValue(x, y);
    let className: string = "text-muted";

    function onFocusOut(): void {
        const oldValue = manager.getValue(x, y);
        if (oldValue == value) return;

        manager.setValue(x, y, value);
    }
</script>

{#if x === y}
    <td class="p-0">
        <div class="diagonal w-100"></div>
    </td>
{:else}
    <td class={className}>
        <input type="number" bind:value={value} min="0" class="w-100" on:focusout={onFocusOut}/>
    </td>
{/if}

<style>
    .diagonal {
        background-color: #869ab8;
        width: 35px;
        height: 35px;
        min-width: 65px;
    }
</style>
